import React from "react";
import "./Bill.scss";
import DynamicHeader from "../../Header/DynamicHeader";
import comingSoon from "../img/cvantik-coming-soon.png";

const Bill = () => {
  return (
    <>
      <DynamicHeader
        title="Платежі"
        variant="glass"
        size="regular"
        showBack
        withSpacer
      />

      <div className="bill">
        <div className="bill-card">
          <div className="coming-soon">
            <img
              className="coming-soon__img"
              src={comingSoon}
              alt="Cvanto — billing coming soon"
            />
            <div className="coming-soon__text">
              <div className="title">Ми щось майструємо…</div>
              <div className="subtitle">Продовження у Beta 2.0</div>
              <p className="note">
                Тут будуть квитанції, історія транзакцій, методи оплати та розумні нагадування. 
                Квантiк дбає, щоб усе збігалося до копійки 🧾✨
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Bill;
